export default "__VITE_ASSET__4mQ6WoSv__"